import {
  BasicSelectInput,
  DateRangeInput,
  BankSelect,
  CurrencyTabs,
} from '@shared/ui/forms/inputs';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ThemeButton } from '@shared/ui/buttons';
import {
  setCardsParams,
  resetCardsFilters,
} from '@app/store/slices/cardsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { cardStatusesOptions } from '@utils/statuses';
import { parseDateQuery, formatDateQuery } from '@utils/date-helpers';
import { groupTeamsByStatus } from '@utils/filters-helpers';
import { useEffect, useMemo } from 'react';
import { RenderItemTeam } from '@shared/ui/forms/select-render';
import { fetchAllGroups } from '@app/store/slices/myTeamSlice';
import { roles } from '@shared/static/roles';
import { fetchBankWallets } from '@app/store/slices/bankWalletsSlice';

export default function CardsFilters({ close }) {
  const { t } = useTranslation();
  const { params } = useSelector((state) => state.cards);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const isMember = user?.group_role === roles.TEAM_MEMBER;
  const { bankWallets } = useSelector((state) => state.bankWallets);
  const { allGroupsWithDeleted } = useSelector((state) => state.my_team);
  const allGroupsWithDeletedGrouped = useMemo(
    () => groupTeamsByStatus(allGroupsWithDeleted, t),
    [allGroupsWithDeleted, t],
  );

  useEffect(() => {
    dispatch(fetchBankWallets());
    if (!isMember) {
      dispatch(fetchAllGroups());
    }
  }, []);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      creationDate:
        params.start_date && params.end_date
          ? [parseDateQuery(params.start_date), parseDateQuery(params.end_date)]
          : null,
      currency: params.currency || null,
      status: params.status || null,
      group_id: params.group_id || null,
      bin: params.bin || null,
    },
  });

  function onSubmit(formData) {
    const start_date = formatDateQuery(formData.creationDate?.[0]);
    const end_date = formatDateQuery(formData.creationDate?.[1]);
    dispatch(
      setCardsParams({
        page: 1,
        bin: formData.bin,
        currency: formData.currency,
        status: formData.status,
        group_id: formData.group_id,
        start_date,
        end_date,
      }),
    );
    close();
  }

  function handleReset() {
    dispatch(resetCardsFilters());
    close();
  }

  return (
    <>
      <div className="block-pd-x drawerFilter-grow cards-filters">
        <div className="form">
          <BankSelect
            control={control}
            name="bin"
            label={t('bank_bin')}
            data={bankWallets}
            valueKey="bin"
          />
          <CurrencyTabs
            control={control}
            name="currency"
            label={t('currency')}
          />
          <BasicSelectInput
            control={control}
            name="status"
            label={t('status')}
            data={cardStatusesOptions}
            valueKey="value"
            labelKey="label"
          />
          {!isMember && (
            <BasicSelectInput
              control={control}
              name="group_id"
              label={t('team')}
              placeholder={t('select_team')}
              Render={RenderItemTeam}
              searchable
              data={allGroupsWithDeletedGrouped}
              groupBy="group"
            />
          )}
          <DateRangeInput
            control={control}
            name="creationDate"
            label={t('creation_date')}
          />
        </div>
      </div>
      <div className="btns-toolbar dialog-actions">
        <ThemeButton startIcon="check" onClick={handleSubmit(onSubmit)}>
          {t('apply')}
        </ThemeButton>
        <ThemeButton appearance="secondary" onClick={handleReset}>
          {t('reset')}
        </ThemeButton>
      </div>
    </>
  );
}
